<template>
	<div class="people-chooser">
		<div class="shortcuts-container">
			<div class="shortcut" v-for="i in buttonCount" @click="clickShortcut(i)">
				<div class="value">{{ i }}</div>
			</div>
		</div>
		<div class="more-people-container" v-if="maxPeople > 10">
			<div class="header" @click="openMorePeople = !openMorePeople">
				<p>{{ getString("more_people_question") }}</p>
				<AppChevronIcon :direction="openMorePeople ? 'up' : 'down'" color="var(--theme-txt1-color)" :size="10"/>
			</div>
			<div class="body">
				<AppDropdown :collapsed="!openMorePeople" white>
					<div class="more-people-num">
						<MenuQuantity ref="more-people-num" :min="11" :max="maxPeople" :value="11"/>
						<MenuButton :title="getString('confirm')" outline @click="confirmMorePeople"/>
					</div>
				</AppDropdown>
			</div>
		</div>
	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import AppChevronIcon from "@/shared/components/AppChevronIcon.vue";
import AppDropdown from "@/shared/components/AppDropdown.vue";
import MenuQuantity from "@/new-menu/components/generic/MenuQuantity.vue";
import MenuButton from "@/new-menu/components/generic/MenuButton.vue";
import {useReservationsStore} from "@/book/stores";

export default {
	components: {MenuButton, AppDropdown, AppChevronIcon, MenuQuantity},
	setup() {
		const languageStore = useLanguageStore();
		const reservationsStore = useReservationsStore();
		return {getString: languageStore.getString, reservationsStore};
	},
	data() {
		return {
			openMorePeople: false
		}
	},
	computed: {
		maxPeople() {
			let timeMax = this.reservationsStore.chosenTime.maxPeople;
			let limit = this.reservationsStore.selectedExperience?.limit_people;
			if (limit !== null) {
				return Math.min(timeMax, limit);
			}
			return timeMax;
		},
		buttonCount() {
			return Math.min(this.maxPeople, 10);
		}
	},
	name: "PeopleChooser",
	methods: {
		clickShortcut(value) {
			this.reservationsStore.chosenPeople = value;
		},
		confirmMorePeople() {
			this.reservationsStore.chosenPeople = this.$refs['more-people-num'].currentValue;
		}
	}
}
</script>

<style scoped lang="scss">
.people-chooser {
	display: flex;
	flex-direction: column;
	background-color: var(--theme-bg2-color);
	width: 100%;
	border-radius: var(--rounded-corner);
	padding: var(--padding-vertical) var(--padding-horizontal);

	.shortcuts-container {
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		width: 100%;
		--num-items-row: 10;
		--gap: var(--padding-horizontal-s);
		gap: var(--gap);

		.shortcut {
			display: flex;
			align-items: center;
			justify-content: center;
			width: calc((100% / var(--num-items-row)) - ((var(--gap) * (var(--num-items-row) - 1)) / var(--num-items-row)));
			height: 40px;
			border-radius: var(--rounded-corner-s);
			border: 1px solid var(--business-color);
			cursor: pointer;
			background-color: var(--business-color-alpha40);
			transition: background-color 0.3s;

			.value {
				font-weight: 500;
				font-size: var(--font-size-l);
				color: var(--business-text-color);
			}

			&:hover {
				background-color: var(--business-color-alpha80);
			}

			@media (max-width: 700px) {
				--num-items-row: 5;
			}

		}
	}

	.more-people-container {
		display: flex;
		flex-direction: column;
		width: 100%;
		margin-top: var(--padding-vertical);
		cursor: pointer;
		border: 1px solid var(--business-color);
		border-radius: var(--rounded-corner-s);
		background-color: var(--theme-bg1-color);

		&:deep(.dropdown-content) {
			box-shadow: none;
		}

		.header {
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 6px var(--padding-horizontal-s);

			p {
				font-size: var(--font-size-s);
				font-weight: 500;
				color: var(--theme-txt1-color);
			}
		}

		.more-people-num {
			display: flex;
			flex-direction: column;
			align-items: center;
			gap: var(--padding-vertical);

			.menu-button {
				max-width: 200px;
			}
		}

	}
}
</style>